export default "__VITE_PUBLIC_ASSET__24a18108__"